import React from "react";
import { Card, CardContent, Typography, Grid, Box } from "@mui/material";
import { FaChartBar, FaDatabase, FaLightbulb, FaChartPie, FaSync, FaShieldAlt, FaEye, FaBrain, FaClipboardList, FaBusinessTime, FaUsers, FaBullseye } from "react-icons/fa";
import OurNumbers from "./OurNumbers";

const BusinessIntelligence = () => {
  return (
    <Box sx={{ padding: "40px", maxWidth: "1200px", margin: "auto" }}>

      <Card
        sx={{
          background: "rgba(0, 0, 0, 0.9)",
          color: "white",
          borderRadius: "12px",
          padding: "30px",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)",
          backdropFilter: "blur(15px)",
          textAlign: "center",
        }}
      >
        <CardContent>
          <Typography variant="h4" fontWeight="bold" gutterBottom>
            Turning Data into Business Success
          </Typography>
          <Typography variant="body1" sx={{ opacity: 0.9 }}>
            Gain deeper insights, improve decision-making, and drive business growth with our cutting-edge Business Intelligence solutions.
          </Typography>
        </CardContent>
      </Card>

      {/* Business Intelligence Services Section */}
      <Grid container spacing={3} sx={{ marginTop: "40px" }}>
        {biServices.map((service, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card sx={glassyCardStyle}>
              <Box sx={logoBox}>{service.icon}</Box>
              <Typography variant="h6" fontWeight="bold">
                {service.title}
              </Typography>
              <Typography variant="body2" sx={{ marginTop: "10px", color: "#222" }}>
                {service.description}
              </Typography>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Statistics Section - Animated UX Grid */}
      <OurNumbers />
    </Box>
  );
};

// Glassy Card Style
const glassyCardStyle = {
  border: "1px solid rgba(255, 255, 255, 0.2)",
  borderRadius: "10px",
  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
  backgroundColor: "rgba(255, 255, 255, 0.15)",
  padding: "20px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
  backdropFilter: "blur(10px)",
  minHeight: "220px",
};

// Stylish Icon Box
const logoBox = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "80px",
  height: "80px",
  borderRadius: "10px",
  backgroundColor: "rgba(211, 154, 158, 0.08)",
  marginBottom: "15px",
  boxShadow: "0 0 5px rgba(211, 154, 158, 0.5), 0 0 10px rgba(211, 154, 158, 0.5), 0 0 20px rgba(211, 154, 158, 0.5)",
  fontSize: "2rem",
};

// Business Intelligence Services (Exclusively BI-related)
const biServices = [
  {
    title: "Data Visualization & Dashboards",
    description: "Transform complex data into interactive, real-time visual dashboards.",
    icon: <FaChartPie />,
  },
  {
    title: "Self-Service Business Intelligence",
    description: "Empower teams with easy-to-use BI tools for data exploration.",
    icon: <FaLightbulb />,
  },
  {
    title: "KPI & Performance Analytics",
    description: "Track key performance indicators to optimize business growth.",
    icon: <FaBullseye />,
  },
  {
    title: "Financial & Operational Reporting",
    description: "Generate automated reports for financial and operational insights.",
    icon: <FaClipboardList />,
  },
  {
    title: "Market & Customer Insights",
    description: "Analyze customer behavior and market trends for strategic decisions.",
    icon: <FaUsers />,
  },
  {
    title: "Competitive Intelligence",
    description: "Monitor competitors and industry trends for better business positioning.",
    icon: <FaBusinessTime />,
  },
  {
    title: "Risk & Compliance Monitoring",
    description: "Identify risks and ensure compliance with business regulations.",
    icon: <FaShieldAlt />,
  },
  {
    title: "Data-Driven Decision Making",
    description: "Enable leadership to make informed, strategic decisions based on data.",
    icon: <FaBrain />,
  },
];

export default BusinessIntelligence;
